const SETONBOARDING = 'SET_ONBOARDING'

export { SETONBOARDING /*, newTypes  */ }
